import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';

import * as viajesActions from 'modules/viajes/action';
import * as generalActions from 'modules/general/action';
import { CancelarButtonC } from 'modules/general/component';
import { GMapsC } from 'modules/general/component';

moment.locale('es');

class Add extends React.Component {
  componentDidMount() {
    const { dispatch, viajeId } = this.props;
    dispatch(generalActions.dashboard_changeTitle('TRAYECTO DEL VIAJE'));

    if (viajeId) {
      dispatch(viajesActions.getPointsTrayecto(viajeId));
      dispatch(viajesActions.getById(viajeId));
    }
  }
  componentWillUnmount = () => this.props.dispatch(viajesActions.clear('viaje'));
  componentDidUpdate = prevProps => {
    const trayecto = this.props.trayecto;
    if (trayecto.size != prevProps.trayecto.size && trayecto.get(0)) this.fitCoor(trayecto.get(0).toJS(), trayecto.get(trayecto.size - 1).toJS());
  };
  setMapRef = map => (this.mapRef = map);
  fitCoor = (salida, destino) => {
    if (this.mapRef && salida && destino) {
      let bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(salida.lat, salida.lng));
      bounds.extend(new window.google.maps.LatLng(destino.lat, destino.lng));
      this.mapRef.fitBounds(bounds);
    }
  };
  render() {
    let { trayecto, viaje } = this.props;
    trayecto = trayecto && trayecto.toJS ? trayecto.toJS() : null;
    const viajeUbicacion = viaje && viaje.getIn(['_localizacion', 0, 'ubicacion']) && viaje.getIn(['_localizacion', 0, 'ubicacion']).toJS();
    return (
      <Container fluid={true}>
        <Row>
          <Col md="8">
            <MaterialUI.Paper zDepth={2} className="padding">
              <MaterialUI.Tabs>
                <MaterialUI.Tab label="Trayecto">
                  <div style={{ height: window.innerHeight - 200 }}>
                    <GMapsC
                      marker={viajeUbicacion}
                      mapRef={map => this.setMapRef(map)}
                      trayecto={trayecto}
                      multipleMarkers={trayecto ? [trayecto[0], trayecto[trayecto.length - 1]] : []}
                      mapElement={<div style={{ height: '100%' }} />}
                      containerElement={<div style={{ height: '100%' }} />}
                    />
                  </div>
                </MaterialUI.Tab>
              </MaterialUI.Tabs>
            </MaterialUI.Paper>
          </Col>
          <Col md="4">
            <MaterialUI.Paper zDepth={2} className="padding">
              <MaterialUI.Tabs>
                <MaterialUI.Tab label="Viaje">
                  <div className="p-lr-10">
                    <Row>
                      <Col md="2">
                        <FontAwesome name="location-arrow" className="fa-2x pt-25" />
                      </Col>
                      <Col md="9">
                        <MaterialUI.TextField disabled underlineDisabledStyle={{ display: 'none' }} defaultValue={viaje.getIn(['_trayecto', 'nombre'])} floatingLabelText="Trayecto" />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="2">
                        <FontAwesome name="clock-o" className="fa-2x pt-25" />
                      </Col>
                      <Col md="9">
                        <MaterialUI.TextField disabled underlineDisabledStyle={{ display: 'none' }} defaultValue={moment(viaje.get('horario')).format('DD/MM/YY HH:mm')} floatingLabelText="Horario" />
                      </Col>
                    </Row>
                    {viaje.get('_chofer') && (
                      <Row>
                        <Col md="2">
                          <FontAwesome name="user-circle-o" className="fa-2x pt-25" />
                        </Col>
                        <Col md="9">
                          <MaterialUI.TextField
                            disabled
                            underlineDisabledStyle={{ display: 'none' }}
                            defaultValue={`${viaje.getIn(['_chofer', 'nombre'])} ${viaje.getIn(['_chofer', 'apellido'])}`}
                            floatingLabelText="Conductor"
                          />
                        </Col>
                      </Row>
                    )}
                  </div>
                </MaterialUI.Tab>
              </MaterialUI.Tabs>
            </MaterialUI.Paper>
          </Col>
        </Row>
        <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />
      </Container>
    );
  }
}

Add = connect((store, props) => ({
  viaje: store.getIn(['viajes', 'viaje']),
  viajeId: (props.params || {}).viajeId,
  trayecto: store.getIn(['viajes', 'puntosDelTrayecto']),
}))(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/viajes/components/mapaTrayecto.js